import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardCertificacionProfesional extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.objeto.institucion}</b>
                            <br />
                            <br />
                            <span className="spanCard">TIPO: </span><b>{this.props.objeto.strTipo}</b>
                            <br />
                            <span className="spanCard">FECHA: </span>{this.parseDate(this.props.objeto.fecha)}
                            <br />
                            <span className="spanCard">PAÍS: </span>{this.props.objeto.strPais}
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                            <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}